import { CommonFlag, type CommonFlagProps, type CommonFlagAction } from '../index';

export type FlagProps = CommonFlagProps & {
	packageName?: string;
};

export default CommonFlag;
export type { CommonFlagAction };
